import { BrowserRouter as Router } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import RtlLayout from './components/RtlLayout'
import ScrollToTop from './components/ScrollToTop'
import { AssetsProvider } from './context/Assets'
import { SiteProvider } from './context/Site'
import { NetworkStatusProvider } from './context/Network'
import ThemeConfig from './theme'
import routes, { renderRoutes } from './routes'

import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { registerAuthListeners, startIntervalSessionCheck, startVisibilityWatcher } from "./auth/listeners";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "ws/start" });
    return () => dispatch({ type: "ws/stop" });
  }, []);

  useEffect(() => {
    registerAuthListeners();
    startVisibilityWatcher();
    startIntervalSessionCheck();
  }, []);

  return (
    <Router>
      <HelmetProvider>
        <ThemeConfig>
          <RtlLayout>
            <SiteProvider>
              <NetworkStatusProvider>
                <AssetsProvider>
                  <ScrollToTop />
                  {renderRoutes(routes)}
                </AssetsProvider>
              </NetworkStatusProvider>
            </SiteProvider>
          </RtlLayout>
        </ThemeConfig>
      </HelmetProvider>
    </Router>
  );
};

export default App;
